import { Stack, type SxProps, type Theme } from "@mui/material";

import { AppSkeletonBlock } from "./AppSkeletonBlock";

interface AppSkeletonTextProps {
  lineCount?: number;
  lineHeight?: number | string;
  widths?: Array<number | string>;
  gap?: number;
  sx?: SxProps<Theme>;
}

export function AppSkeletonText(props: AppSkeletonTextProps) {
  const { lineCount = 3, lineHeight = 16, widths, gap = 1, sx } = props;
  const lineWidths =
    widths ??
    Array.from({ length: lineCount }, (_, index) => {
      if (index === lineCount - 1) {
        return `${Math.max(56, 84 - index * 8)}%`;
      }

      return `${Math.max(72, 100 - index * 6)}%`;
    });

  return (
    <Stack spacing={gap} sx={sx}>
      {lineWidths
        .reduce<Array<{ key: string; width: number | string }>>((items, width) => {
          const widthString = String(width);
          const duplicateCount = items.filter((item) => item.width === width).length + 1;

          items.push({
            key: `${widthString}-${duplicateCount}`,
            width,
          });

          return items;
        }, [])
        .map((item) => (
          <AppSkeletonBlock key={item.key} height={lineHeight} width={item.width} />
        ))}
    </Stack>
  );
}
